import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const ClientPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      primary: {
        color: '{violet}',

        hover: {
          color: '{violet-70}',
        },
      },
      highlight: {
        background: '{violet}',
        color: '{black}',

        focus: {
          background: '{violet-70}',
          borderColor: '{violet-70}',
          color: '{black}',
        },

        hover: {
          background: '{violet-70}',
          borderColor: '{violet-70}',
          color: '{black}',
        },
      },
      primitive: {
        primary: {
          50: '{violet-50}',
          10: '{violet-30}',
          30: '{violet-30}',
          120: '{violet}',
          200: '{violet}',
        },
        error: '{red}',
        success: '{green}',
        warning: '{gold}',
        white: '{white}',
      },
      formField: {
        border: {
          color: '{gray2}',
          radius: '20px',
        },

        color: '{black}',
        placeholderColor: '{gray3}',

        shadow: 'none',

        paddingX: '10px',
        paddingY: '12px',

        iconColor: '{black-40}',

        transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',

        hover: {
          borderColor: '{violet}',
        },

        invalid: {
          borderColor: '{red}',
          placeholderColor: '{gray3}',
          focus: {
            placeholderColor: '{gray3}',
          },
        },

        focus: {
          borderColor: '{violet}',
          ringColor: '{violet-50}',
          ringWidth: '2px',
          ringStyle: 'solid',
        },

        disabled: {
          background: '{gray2}',
        },
      },
      datepicker: {
        fontSize: '13px',
        paddingY: '10px',

        today: {
          color: '{primary}',
          background: '{black-10}',
        },

        select: {
          monthBackgroundColor: '{violet-70}',
          yearBackgroundColor: '{violet-70}',
        },
      },
    },
  },
  components: {
    fileupload: {
      border: {
        color: '{gray2}',
        radius: '20px',
      },

      header: {
        padding: '0',
      },

      progressbar: {
        height: '0',
      },

      content: {
        padding: '8px',
        gap: '0',
      },
    },
    select: {
      paddingY: '10px',
    },
    datepicker: {
      date: {
        height: '30px',
        width: '30px',
      },

      weekDay: {
        fontWeight: 'bold',
      },
    },
    paginator: {
      background: 'transparent',
      gap: '8px',

      navButton: {
        color: '{black}',
        background: 'transparent',

        width: '30px',
        height: '30px',

        hover: {
          color: '{black}',
          background: '{violet-70}',
        },

        selected: {
          background: '{violet}',
        },
      },

      currentPageReport: {
        color: '{black}',
      },
    },
    button: {
      colorScheme: {
        primary: {
          background: '{violet}',
          color: '{black}',
        },
        text: {
          primary: {
            color: '{black-70}',
            hover: {
              background: '{gray3}',
            },
            active: {
              background: '{gray2}',
            },
          },
        },
        danger: {
          background: '{red}',
          color: '{white}',
        },
        success: {
          background: '{blue}',
          color: '{black}',
        },
        warning: {
          background: '{gold}',
          color: '{black}',
        },
      },
    },
    checkbox: {
      width: '20px',
      height: '20px',

      colorScheme: {
        hover: {
          background: '{black-70}',
        },
        checked: {
          hover: {
            background: '{violet}',
            borderColor: '{violet}',
          },
        },
      },
    },
    datatable: {
      header: {
        background: '{gray1}',
        cell: {
          background: '{gray1} !important',
        },
      },
    },
    tabs: {
      tab: {
        active: {
          background: '{violet}',
        },

        hover: {
          background: '{violet-70}',
          borderColor: '{violet-70}',
        },
      },
      tablist: {
        background: 'transparent',
      },
      tabpanel: {
        background: 'transparent',
      },
    },
    toast: {
      color: '{black}',
      borderRadius: '16px',
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2}',

      textGap: '0',
      detailFontSize: '16px',
      colorScheme: {
        info: {
          borderColor: 'transparent',
          background: '{violet}',
          detailColor: '{black}',
          color: '{black}',
          shadow: '0px 5px 40px 0px rgba(0,0,0,0.5)',

          closeButton: {
            hover: {
              background: '{black-10}',
            },
          },
        },
        error: {
          borderColor: 'transparent',
          background: '{red}',
          detailColor: '{white}',
          color: '{white}',
          shadow: '0px 5px 40px 0px rgba(0,0,0,0.5)',

          closeButton: {
            hover: {
              background: '{black-10}',
            },
          },
        },
        success: {
          borderColor: 'transparent',
          background: '{green}',
          detailColor: '{black}',
          color: '{black}',
          shadow: '0px 2px 10px 0px rgba(0,0,0,0.5)',

          closeButton: {
            hover: {
              background: '{black-10}',
            },
          },
        },
        warn: {
          borderColor: 'transparent',
          background: '{gold}',
          detailColor: '{black}',
          color: '{black}',
          shadow: '0px 5px 40px 0px rgba(0,0,0,0.5)',

          closeButton: {
            hover: {
              background: '{black-10}',
            },
          },
        },
      },
    },
    tree: {
      colorScheme: {},
    },
    popover: {
      borderRadius: '8px 28px 28px 28px',

      content: {
        padding: '4px',
      },
    },
  },
});
